import { Component, Input, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ReportsService } from 'src/app/core/services/reports.service';
import { ReportTabBase } from '../report-tab.base';

@Component({
    selector: 'app-scholars-report',
    templateUrl: './scholars-report.component.html',
    styleUrl: '../report-tab.scss',
})
export class ScholarsReportComponent extends ReportTabBase {
    @Input() policyStatuses: any[] = [];
    @Input() users: any[] = [];
    @Input() canFilterByUser = false;

    private readonly reportsService = inject(ReportsService);

    readonly form = new FormGroup({
        startDate: new FormControl(),
        endDate: new FormControl(),
        partnerId: new FormControl(),
        status: new FormControl(),
        userId: new FormControl(),
    });

    reports: any[] = [];

    submit(): void {
        const value = this.form.getRawValue();
        const payload = {
            startDate: this.toReportDate(value.startDate),
            endDate: this.toReportDate(value.endDate),
            partnerId: value.partnerId || null,
            status: value.status || null,
            userId: value.userId || null,
        };

        this.startLoading('Creating Scholars Report');
        this.reportsService.fetchScholarsReport(payload).subscribe({
            next: (response) => {
                this.reports = response.policyList || [];
                this.stopLoading();
                this.messageService.add({
                    severity: 'success',
                    summary: 'Search',
                    detail: 'Scholars report generated successfully',
                });
            },
            error: (err) => {
                this.showError(err.error.message);
                this.stopLoading();
            },
        });
    }

    export(): void {
        this.exportTable('Scholars_Report');
    }
}
